"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeValueHandlerAdapter_1 = require("./NodeValueHandlerAdapter");
/**
 * Converts GraphQL lists to RDF lists if settings.arraysToRdfLists is true, otherwise it converts to multiple values.
 */


var NodeValueHandlerList =
/*#__PURE__*/
function (_NodeValueHandlerAdap) {
  _inherits(NodeValueHandlerList, _NodeValueHandlerAdap);

  function NodeValueHandlerList(util, settings) {
    var _this;

    _classCallCheck(this, NodeValueHandlerList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NodeValueHandlerList).call(this, 'ListValue', util, settings));
    _this.nodeFirst = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#first');
    _this.nodeRest = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#rest');
    _this.nodeNil = _this.util.dataFactory.namedNode('http://www.w3.org/1999/02/22-rdf-syntax-ns#nil');
    return _this;
  }

  _createClass(NodeValueHandlerList, [{
    key: "handle",
    value: function handle(valueNode, fieldName, convertContext) {
      var listTerms = [];
      var auxiliaryPatterns = []; // Create terms for list values

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = valueNode.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var v = _step.value;
          var subValue = this.util.handleNodeValue(v, fieldName, convertContext);
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = subValue.terms[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _term = _step3.value;
              listTerms.push(_term);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          if (subValue.auxiliaryPatterns) {
            auxiliaryPatterns = auxiliaryPatterns.concat(subValue.auxiliaryPatterns);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.settings.arraysToRdfLists) {
        // Convert array to RDF list
        // Create chained list structure
        var firstListNode = this.util.dataFactory.blankNode();
        var listNode = firstListNode;
        var remaining = listTerms.length;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = listTerms[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var term = _step2.value;
            auxiliaryPatterns.push(this.util.operationFactory.createPattern(listNode, this.nodeFirst, term, convertContext.graph));
            var nextListNode = --remaining === 0 ? this.nodeNil : this.util.dataFactory.blankNode();
            auxiliaryPatterns.push(this.util.operationFactory.createPattern(listNode, this.nodeRest, nextListNode, convertContext.graph));
            listNode = nextListNode;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return {
          terms: [firstListNode],
          auxiliaryPatterns: auxiliaryPatterns
        };
      } else {
        // Convert array to multiple terms that will be linked via the same predicate.
        return {
          terms: listTerms,
          auxiliaryPatterns: auxiliaryPatterns
        };
      }
    }
  }]);

  return NodeValueHandlerList;
}(NodeValueHandlerAdapter_1.NodeValueHandlerAdapter);

exports.NodeValueHandlerList = NodeValueHandlerList;